import React, { useState, useRef } from "react";
import { database } from "../../firebase";  // Import from firebase.js
import { push, set, ref as dbRef } from "firebase/database";
import "./Form_module.scss";

const FormComponent = () => {
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [imagePreview, setImagePreview] = useState(null); // Keep only imagePreview
  const [review, setReview] = useState("");

  const fileInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Set image as Base64 string
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // This is the Base64 string
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); 

    // Check if all required fields are filled
    if (!name || !designation || !review || !imagePreview) {
      alert("Please fill all fields and upload an image.");
      return;
    }

    try {
      // Save form data to Firebase Realtime Database
      const reviewsRef = dbRef(database, "reviews");
      const newReviewRef = push(reviewsRef);
      await set(newReviewRef, {
        name,
        designation,
        review,
        image: imagePreview,  // Store the Base64 image data
      });

      alert("Review submitted successfully!");

      // Clear form data after successful submission
      setName("");
      setDesignation("");
      setReview("");
      setImagePreview(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error submitting the review:", error);
      alert("There was an error submitting your review.");
    }
    finally {
      setIsSubmitting(false); // Stop loading
    }
  };

  const handleReset = () => {
    setName("");
    setDesignation("");
    setImagePreview(null); // Reset imagePreview
    setReview("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h2 className="text-center">User Form</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Upload Image</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleImageChange}
            />
          </div>

          {/* Image Preview */}
          {imagePreview && (
  <div className="mb-3 text-center preview-container">
    <button
      type="button"
      className="btn-close-preview"
      onClick={() => setImagePreview(null)}
    >
      ×
    </button>
    <img
      src={imagePreview}
      alt="Preview"
      className="img-thumbnail preview-image"
      style={{ maxWidth: "200px", maxHeight: "200px" }}
    />
  </div>
)}


          <div className="mb-3">
            <label className="form-label">Review Content</label>
            <textarea
              className="form-control"
              value={review}
              onChange={(e) => setReview(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
  {isSubmitting ? "Submitting..." : "Submit"}
</button>

          <button
            type="button"
            className="btn btn-secondary w-100 mt-2"
            onClick={handleReset}
          >
            Reset
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormComponent;
